import axios from 'axios'

const instance = axios.create({
    baseURL: "https://www.yaoking.cn/",
    timeout: 3000
})

// 请求拦截
instance.interceptors.request.use(
    function (config) {
        // config.headers.emulateJSON = true
        // config.data = config.params
        config.headers = {
            // text/plain;charset=UTF-8
            // application/x-www-form-urlencoded
            // application/json; charset=utf-8
            'Content-Type': "application/x-www-form-urlencoded"
        }
        console.log(config)
        return config
    }
)
// 响应拦截
instance.interceptors.response.use(
    function (response) {
        // console.group(response, "响应拦截")
        // if (response.status === 200) {//正常
        //     // this.time = false
        //     return Promise.resolve(response)
        // } else {
        //     return Promise.reject(response)
        // }
        return response;
    },
    error => { //异常
        if (error) {
            // this.$router.push({//跳转404
            //     path: `/error`
            // })
            // console.log(error.response,"error.response.status")
            // Toast.fail(error.response.data.msg);    
            // switch (error.response.status) {
            //     case 404:
            //         console.log('404')
            //         break
            //     // 其他错误，直接抛出
            //     default:
            // }
            return Promise.reject(error.response)
        }
    }
)
export default instance
